import { useEffect } from "react";
import ReactConfetti from "react-confetti";
import { useWindowSize } from "react-use";

import { Particles } from "@circle-react/apps/EoyRecapApp/Sections/components/Particles";
import { NavigationTabs } from "@circle-react/apps/EoyRecapApp/Sections/components/NavigationTabs";

import { Hero } from "@circle-react/apps/EoyRecapApp/Sections/components/Hero";
import { Engagement } from "@circle-react/apps/EoyRecapApp/Sections/Engagement";
import { Community } from "@circle-react/apps/EoyRecapApp/Sections/Community";
import { EOY_RECAP_VIEW_TYPES } from "@circle-react/apps/EoyRecapApp/constants";
import { Loader } from "@/react/components/shared/uikit/Loader";

import { useAdminMetrics } from "./hooks/useAdminMetrics";
import { Reach } from "@/react/apps/EoyRecapApp/Sections/Reach";
import { Efficiency } from "@/react/apps/EoyRecapApp/Sections/Efficiency";
import { Impact } from "@/react/apps/EoyRecapApp/Sections/Impact";
import { Members } from "@/react/apps/EoyRecapApp/Sections/Members";

export const EoYRecap2025Page = () => {
  const { width, height } = useWindowSize();
  const { metrics, isMetricsLoading } = useAdminMetrics();

  useEffect(() => {
    const scrollContext = EOY_RECAP_VIEW_TYPES.ADMIN;
    const scrollContainer =
      scrollContext === "admin"
        ? document.getElementById("panel") || document.documentElement
        : document.documentElement;

    if (!scrollContainer) return;

    scrollContainer.style.scrollSnapType = "y mandatory";
    scrollContainer.style.scrollBehavior = "smooth";
    scrollContainer.style.scrollPaddingTop = "80px";

    return () => {
      const container =
        scrollContext === "admin"
          ? document.getElementById("panel") || document.documentElement
          : document.documentElement;

      if (container) {
        container.style.scrollSnapType = "";
        container.style.scrollBehavior = "";
        container.style.scrollPaddingTop = "";
      }
    };
  }, []);

  if (isMetricsLoading)
    return (
      <div className="size-full flex items-center justify-center">
        <Loader />
      </div>
    );

  return (
    <main className="bg-[#0F0F35]">
      <ReactConfetti
        width={width}
        height={height}
        style={{
          zIndex: 999999,
        }}
        recycle={false}
        tweenDuration={6000}
        numberOfPieces={100}
        gravity={0.15}
        wind={0.05}
        colors={[
          "#a855f7",
          "#9333ea",
          "#7e22ce",
          "#6b21a8",
          "#ffffff",
          "#fbbf24",
          "#f59e0b",
        ]}
        initialVelocityY={-20}
        initialVelocityX={15}
      />
      <Particles />
      <NavigationTabs scrollContext={EOY_RECAP_VIEW_TYPES.ADMIN} />
      <div className="snap-start min-h-screen">
        <Hero />
      </div>
      <div className="snap-start min-h-screen">
        <Community data={metrics?.community_growth} />
      </div>
      <div className="snap-start min-h-screen">
        <Members data={metrics?.member_engagement} />
      </div>
      <div className="snap-start min-h-screen">
        <Engagement data={metrics?.content_experience} />
      </div>
      <div className="snap-start min-h-screen">
        <Reach data={metrics?.email_highlights} />
      </div>
      <div className="snap-start min-h-screen">
        <Impact data={metrics?.business_impact} />
      </div>
      <div className="snap-start min-h-screen">
        <Efficiency data={metrics?.automation_efficiency} />
      </div>
    </main>
  );
};
